import { create } from "@/api/launcherApp/signup"
import type { TApiSignupCreateParams, TApiSignupCreateResponse } from "@/api/launcherApp/signup/schema"
import { createScopedLogger } from "@/lib/observability"

const logger = createScopedLogger("signup", {
  action: "create",
})

export async function actionCreateSignup(params: TApiSignupCreateParams): Promise<{ success: boolean; data?: TApiSignupCreateResponse }> {
  try {
    const result = await create(params)
    return { success: true, data: result }
  } catch (error) {
    await logger.error("signup.create.action_failed", error)
    return { success: false }
  }
}
